//create CRUD class with axios
import axios, { AxiosResponse } from "axios";
import DataService from "./dataservice.base";


export default class MainDataService extends DataService {
  // อยู่บน report service ตัวเดียวกัน (Express บน DigitalOcean) ไม่ใช่ core API
  protected get URL(): string {
    return useBaseUrl("report");
  }

  constructor(path: string) {
    super(path);
  }

  async changePassword(params:any){
    return await axios.post(`${this.URL}/change-password`, params);
  }

}

// Nuxt auto-import (unimport) ลงทะเบียนชื่อคลาสนี้เป็น named export
// จึงต้อง export ชื่อออกไปด้วย ไม่งั้น build จะ resolve ไม่เจอ
// ส่วน default export ตัวเดิมยังอยู่ ผู้ที่ import แบบเดิมไม่กระทบ
export { MainDataService };
